import { Button, Input, Select } from 'antd';
import { FormattedMessage } from 'react-intl';

import ProfileCard from '../../components/Cards/ProfileCard';
import ChangePassword from '../../components/ChangePassword/ChangePassword';
import Icon from '../../components/Icon/Icon';
import Spinner from '../../components/Spinner/Spinner';
import UploadImage from '../../components/UploadImage/UploadImage';

import styles from './AdminProfile.module.scss';

import { useAdminProfile } from './useAdminProfile';

const AdminProfile = () => {

  const {
    i18nCountries,
    setEmail,
    setProfile,
    state,
    togglePasswordPopup,
    toggleEmailField,
    toggleImagePopup,
    toggleLocationField,
    toggleNameField,
    updateEmail,
    updatePersonalInformation,
  } = useAdminProfile();

  const {
		editEmail,
		editImage,
		editLocation,
		editName,
		email,
		isInvalidEmail,
		loading,
		profile,
		showPasswordPopup
	} = state;

  return <div className={styles.pageContainer}>
      <div className={`${styles.pageSider} ${styles.topBorder} ${styles.noPadding}`}>
        {profile && <ProfileCard
          fitContainer
          interactiveImage
          onClick={toggleImagePopup}
          showData
          data={{
            imageId: profile.imageId,
            name: `${profile.firstName} ${profile.lastName}`,
          }}
        />}
      </div>
    <div className={styles.pageContent}>
      <div className={`${styles.mobileTopper} ${styles.topBorder} ${styles.noPadding}`}>
        {profile && <ProfileCard
          fitContainer
          interactiveImage
          onClick={toggleImagePopup}
          showData
          data={{
            imageId: profile.imageId,
            name: `${profile.firstName} ${profile.lastName}`,
          }}
        />}
      </div>
      <div className={styles.mainActions}>
        <div className={styles.breadcrumbs}>
          <span>{profile?.firstName} {profile?.lastName}</span>
          <b><span><FormattedMessage id="navigation.myProfile" /></span></b>
        </div>
      </div>
      <div className={styles.content}>
				<Spinner delay={0} spinning={loading} />
        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="envelope" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.name" /></h2>
          </div>
          <div className={styles.categoryContent}>
            {!editName ? <>
              <p>{profile?.firstName} {profile?.lastName}</p>
              <Button type="link" onClick={toggleNameField}><FormattedMessage id="buttons.edit" /></Button>
            </> :
              <>
                <Input defaultValue={profile?.firstName} onChange={(event) => {
                  if (event.target.value && profile) setProfile({ ...profile, firstName: event.target.value });
                }} />
                <Input defaultValue={profile?.lastName} onChange={(event) => {
                  if (event.target.value && profile) setProfile({ ...profile, lastName: event.target.value });
                }} />
								<div>
                	<Button type="link" onClick={() => { updatePersonalInformation(); toggleNameField(); }}><FormattedMessage id="buttons.save" /></Button>
									<Button type="text" onClick={toggleNameField}><FormattedMessage id="buttons.cancel" /></Button>
								</div>
							</>}
          </div>
        </div>

        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="map-marker" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.location" /></h2>
          </div>
          <div className={styles.categoryContent}>
            {!editLocation ? <>
              <p>{profile?.location}</p>
              <Button type="link" onClick={toggleLocationField}><FormattedMessage id="buttons.edit" /></Button>
            </> :
              <>
                <Select
                  className={styles.select}
                  filterOption={(input, option: any) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  onChange={(event) => {
                    if (event && profile) setProfile({ ...profile, location: event.toString() });
                  }}
                  showArrow={false}
                  showSearch={true}
                >
                  {Object.keys(i18nCountries).map(code => (
                    <Select.Option key={code} value={code}>{i18nCountries[code]}</Select.Option>
                  ))}
                </Select>
								<div>
                	<Button type="link" onClick={() => { updatePersonalInformation(); toggleLocationField(); }}><FormattedMessage id="buttons.save" /></Button>
									<Button type="text" onClick={toggleLocationField}><FormattedMessage id="buttons.cancel" /></Button>
								</div>
              </>}
          </div>
        </div>

        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="envelope" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.email" /></h2>
          </div>
          <div className={styles.categoryContent}>
            {!editEmail ? <>
              <p>{email}</p>
              <Button type="link" onClick={toggleEmailField}><FormattedMessage id="buttons.edit" /></Button>
            </> :
              <>
                <Input type="email" className={styles.emailInput} defaultValue={email} onChange={(event) => {
                  setEmail(event.target.value);
                }} />
								<div>
									<Button disabled={isInvalidEmail} type="link" onClick={() => { updateEmail(); toggleEmailField(); }}><FormattedMessage id="buttons.save" /></Button>
									<Button type="text" onClick={toggleEmailField}><FormattedMessage id="buttons.cancel" /></Button>
								</div>
              </>}
          </div>
        </div>

        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="lock" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.password" /></h2>
          </div>
          <div className={styles.categoryContent}>
            <Button type="link" onClick={togglePasswordPopup}>
              <FormattedMessage id="buttons.changePassword" />
            </Button>
          </div>
        </div>
      </div>
    </div>
    {showPasswordPopup && <ChangePassword onClose={togglePasswordPopup} />}
    {editImage && <UploadImage onClose={toggleImagePopup} currentUser={profile} afterClosed={(data) => { setProfile(data) }} />}
  </div>
}
export default AdminProfile;